<template>
    <Widget :title="$t('components.TopQuestions.Title')" :info="$t('widgetsInfo.TopQuestions')" :loading="loading" v-resize="onResize" :report-mode="reportMode">
        <ProgressBarChart :items="stats" unit="Chats"/>
    </Widget>
</template>

<script>
/**
 * TopQuestions wraps a ProgressBarChart and contains the functions to
 * parse data from the API.
 *
 * It represents the top 8 questions asked on chats.
 */
import Widget from '@/components/dashboard/Widget';

import ProgressBarChart from '@/components/dashboard/charts/ProgressBarChart';

export default {
    name: 'TopQuestions',
    data: () => ({
        stats: [],
        mobile: false
    }),
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        chatsData: {
            type: Object,
            required: true,
        },
        reportMode: {
            type: String,
            default: null
        }
    },
    watch: {
        chatsData(newData) {
            this.updateStats(newData);
        }
    },
    mounted() {
        this.updateStats(this.chatsData);
    },
    methods: {
        updateStats(data) {
            if (data) {
                this.stats = Object.keys(data).map(item => ({
                    label: item, value: data[item]
                })).slice(0, 12);
            }
        },
        onResize() {
            this.mobile = window.innerWidth < 600;
        }
    },
    components: {
        Widget,
        ProgressBarChart
    }
}
</script>
